import {IActivityNotification} from "../../activity-notifications/activity-notification";
import {
  IActivityNotificationsState,
  IWebsiteActivityNotificationsState
} from "../reducers/activity-notifications.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getActivityNotificationsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.activityNotifications);

export const getActivityNotifications = createSelector(getActivityNotificationsState,
  (state: IActivityNotificationsState): IActivityNotification[] => {
    const activityNotifications: IActivityNotification[] = Object.values(state.entities)
      .filter((websiteActivityNotificationsState: IWebsiteActivityNotificationsState): boolean => !!websiteActivityNotificationsState.entities)
      .map((websiteActivityNotificationsState: IWebsiteActivityNotificationsState): IActivityNotification[] => Object.values(websiteActivityNotificationsState.entities))
      .reduce((activityNotifications: IActivityNotification[], websiteActivityNotifications: IActivityNotification[]): IActivityNotification[] => {
        return activityNotifications.concat(websiteActivityNotifications);
      }, [])
      .sort((n1: IActivityNotification, n2: IActivityNotification): number => n2.date.getTime() - n1.date.getTime());
    return activityNotifications;
  }
);

export const getNewActivityNotifications = createSelector(getActivityNotificationsState,
  (state: IActivityNotificationsState): IActivityNotification[] => {
    const newActivityNotifications: IActivityNotification[] = Object.values(state.entities)
      .filter((websiteActivityNotificationsState: IWebsiteActivityNotificationsState): boolean => !!websiteActivityNotificationsState.entities)
      .map((websiteActivityNotificationsState: IWebsiteActivityNotificationsState): IActivityNotification[] => Object.values(websiteActivityNotificationsState.entities))
      .reduce((activityNotifications: IActivityNotification[], websiteActivityNotifications: IActivityNotification[]): IActivityNotification[] => {
        return activityNotifications.concat(websiteActivityNotifications);
      }, [])
      .filter((activityNotification: IActivityNotification) => activityNotification.isNew);

    return newActivityNotifications;
  }
);

export const getActivityNotificationsLoading = createSelector(getActivityNotificationsState,
  (state: IActivityNotificationsState): boolean =>
    state.loading
);

export const getActivityNotificationsLoaded = createSelector(getActivityNotificationsState,
  (state: IActivityNotificationsState): boolean =>
    state.loaded
);

export const getActivityNotificationsToggled = createSelector(getActivityNotificationsState,
  (state: IActivityNotificationsState): boolean =>
    state.toggled
);
